import { render, staticRenderFns } from "./CartaoInformacoesComplexidade.vue?vue&type=template&id=005cb960&scoped=true"
import script from "./CartaoInformacoesComplexidade.vue?vue&type=script&lang=js"
export * from "./CartaoInformacoesComplexidade.vue?vue&type=script&lang=js"
import style0 from "./CartaoInformacoesComplexidade.vue?vue&type=style&index=0&id=005cb960&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005cb960",
  null
  
)

export default component.exports